



import styled from "styled-components"
import {GoCheck} from "react-icons/go"
import { useDispatch } from "react-redux"
import { updatePaketlemeItem, updateYukData } from "../../../../../features/updateLoad/updateLoadSlice"

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    .box{
        width: 18px;
        height: 18px;
        border-radius: 3px;
        border: 2px solid ${({theme}) => theme.mainTextColor};
        display: flex;
        justify-content: center;
        align-items: center;

        .check-icon{
            font-size: 1rem;
            fill: ${({theme}) => theme.mainTextColor};
        }
    }

    .label{
        font-size: var(--font-size-sm);
        font-size: 12px;
        font-weight: var(--font-weight-xl);
    }
`

const YukunUzerineBaskaYukCheckBox = ({ data, labelText="Yükün üzerine başka yük yüklenmesin"}) => {

    const dispatch = useDispatch()

  return (
    <Container>
        <div className="box" onClick={() => dispatch(updateYukData({ustUsteYuklenmesin: !data.ustUsteYuklenmesin}))}>{data.ustUsteYuklenmesin && <GoCheck className="check-icon"/>}</div>
        <div className="label">{labelText}</div>
    </Container>
  )
}

export default YukunUzerineBaskaYukCheckBox